const thresholdBreaks = {
  student: [14, 15, 16, 17, 18, 19, 20, 26, 31],
  subject: [15, 16, 17, 18],
}

export default thresholdBreaks


// WEBPACK FOOTER //
// ./src/helpers/assessment/thresholdBreaks.js